export const PLAID = {
    COUNTRY_CODES: process.env.REACT_APP_PLAID_COUNTRY_CODES || 'US',
    PUBLIC_KEY: process.env.REACT_APP_PLAID_PUBLIC_KEY || '',
    PRODUCTS: process.env.REACT_APP_PLAID_PRODUCTS || 'transactions',
    ENV: process.env.REACT_APP_PLAID_ENV || 'sandbox',
}

